import { render, staticRenderFns } from "./DynamicProduct.vue?vue&type=template&id=d9efd50a&"
import script from "./DynamicProduct.vue?vue&type=script&lang=js&"
export * from "./DynamicProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports